import { useEffect } from 'react';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ChapterNav from './ChapterNav';
import JacketProgress from './JacketProgress';
import Ch1Raw from './chapters/Ch1Raw';
import AboutIntro from './chapters/AboutIntro';
import Ch2Selection from './chapters/Ch2Selection';
import Ch3Pattern from './chapters/Ch3Pattern';
import Ch4Cutting from './chapters/Ch4Cutting';
import Ch5Stitching from './chapters/Ch5Stitching';
import Ch6Hardware from './chapters/Ch6Hardware';
import Ch7Inspection from './chapters/Ch7Inspection';
import Ch8Reveal from './chapters/Ch8Reveal';
import Ch9Global from './chapters/Ch9Global';
import Ch11About from './chapters/Ch11About';
import ChArchive from './chapters/ChArchive';
import Ch10Partner from './chapters/Ch10Partner';

gsap.registerPlugin(ScrollTrigger);

export default function Experience() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    lenis.on('scroll', ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener('load', onLoad);
    const t = setTimeout(() => ScrollTrigger.refresh(), 1500);
    return () => {
      clearTimeout(t);
      window.removeEventListener('load', onLoad);
      gsap.ticker.remove(raf);
      ScrollTrigger.getAll().forEach((st) => st.kill());
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main data-testid="experience-page" className="relative bg-[#0A0A0A] text-[#F5F5F0]">
      <div className="grain-overlay" />
      <ChapterNav />
      <JacketProgress />
      <Ch1Raw />
      <AboutIntro />
      <Ch2Selection />
      <Ch3Pattern />
      <Ch4Cutting />
      <Ch5Stitching />
      <Ch6Hardware />
      <Ch7Inspection />
      <Ch8Reveal />
      <Ch11About />
      <Ch9Global />
      <ChArchive />
      <Ch10Partner />
    </main>
  );
}
